export default {
    dependencies: ['$element', 'filtersservice'],
    callable(ele, filtersservice) {
        ele.addEventListener('click', event => {
            event.stopPropagation();
            if (filtersservice) {
                filtersservice.show();
            }
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/showFilters.js